(function(){
    'use strict';

    class ActivityService {
        constructor($q, $mdDialog, $translate, moment, CoreUserService, InfluencerContactService) {
            this.$q = $q;
            this.$mdDialog = $mdDialog;
            this.$translate = $translate;
            this.moment = moment;
            this.CoreUserService = CoreUserService;
            this.InfluencerContactService = InfluencerContactService;
        }

        _openActivityModal(callback, activity) {
            var _this = this,
                createdString,
                updatedString;

            activity = activity || {};
            activity.date = activity.date ? _this.moment(activity.date) : _this.moment();

            function createTimeString(action, author, datetime) {
                var date = _this.moment(datetime).format('MMMM Do YYYY'),
                    time = _this.moment(datetime).format('h:mm a'),
                    bemKey,
                    stamp;

                if(author && author.firstName && author.lastName) {
                    bemKey = ((action === 'created') ? 'icm-web__contact-profile--activity-created' : 'icm-web__contact-profile--activity-updated');

                    stamp = _this.$translate.instant(bemKey, {firstName: author.firstName, lastName: author.lastName, date: date, time: time});
                } else {
                    bemKey = ((action === 'created') ? 'icm-web__contact-profile--activity-created-noname' : 'icm-web__contact-profile--activity-updated-noname');

                    stamp = _this.$translate.instant(bemKey, {date: date, time: time});
                }

                return stamp;
            }

            if(activity.createdAt) {
                createdString = createTimeString('created', activity.createdBy, activity.createdAt);

                if(activity.modifiedAt && (activity.modifiedAt !== activity.createdAt)) {
                    updatedString = createTimeString('updated', activity.updatedBy, activity.modifiedAt);
                }
            }

            this.$mdDialog.show({
                autoWrap: false,
                bindToController: true,
                fullscreen: true,
                locals: {
                    selectedType: activity.type,
                    subject: activity.subject,
                    body: activity.note,
                    date: activity.date,
                    createdString: createdString || null,
                    updatedString: updatedString || null,
                    cancelDialog: function() {
                        _this.$mdDialog.cancel();
                    },
                    okDialog: function(selectedType, subject, body, date) {
                        date = date.format('L');
                        callback(selectedType, subject, body, date);

                        _this.$mdDialog.hide();
                    },
                },
                template: `
                    <md-dialog id="icm-activity-modal" class="mw-mini-modal" aria-label="" layout="column">
                        <mw-activity-modal class="mw-mini-modal-wrapper" layout="column" created-string="$ctrl.createdString" updated-string="$ctrl.updatedString" selected-type="$ctrl.selectedType" subject="$ctrl.subject" body="$ctrl.body" date="$ctrl.date" cancel-callback="$ctrl.cancelDialog()" ok-callback="$ctrl.okDialog(selectedType, subject, body, date)"></mw-activity-modal>
                    </md-dialog>
               `,
                // This is a globally available controller for the purposes of attaching locals for data binding
                controller: 'MwMiniModalDialogController',
                controllerAs: '$ctrl'
            });
        }

        createActivity(contactId) {
            var _this = this;

            return _this.$q((resolve) => {
                function performAdd(selectedType, subject, body, date) {
                    _this.CoreUserService.getCurrent(true).then(function(user) {
                        var author = {
                            id: user._id,
                            firstName: user.firstName,
                            lastName: user.lastName,
                            email: user.email
                        };

                        var createPromise = _this.InfluencerContactService.addActivity(contactId, selectedType, subject, body, date, author);
                        resolve(createPromise);
                    });
                }

                _this._openActivityModal(performAdd);
            });
        }

        updateActivity(contactId, oldActivity) {
            var _this = this;

            return _this.$q((resolve) => {
                function performUpdate(selectedType, subject, body, date) {
                    _this.CoreUserService.getCurrent(true).then(function(user) {
                        var author = {
                                id: user._id,
                                firstName: user.firstName,
                                lastName: user.lastName,
                                email: user.email
                            },
                            activityId = oldActivity.notesId;

                        var updatePromise = _this.InfluencerContactService.editActivity(activityId, contactId, selectedType, subject, body, date, author);
                        resolve(updatePromise);
                    });
                }

                _this._openActivityModal(performUpdate, oldActivity);
            });
        }

        getActivityTypes() {
            return [
                {
                    value: 'email',
                    display: this.translateActivityType('email')
                },
                {
                    value: 'phone_call',
                    display: this.translateActivityType('phone_call')
                },
                {
                    value: 'note',
                    display: this.translateActivityType('note')
                },
                {
                    value: 'meeting',
                    display: this.translateActivityType('meeting')
                },
                {
                    value: 'other',
                    display: this.translateActivityType('other')
                }
            ];
        }

        translateActivityType(type) {
            var translation;
            switch (type){
                case 'note':
                    translation = this.$translate.instant('icm-web__contact-profile--activity-type-note');
                    break;
                case 'phone_call':
                    translation = this.$translate.instant('icm-web__contact-profile--activity-type-phone');
                    break;
                case 'meeting':
                    translation = this.$translate.instant('icm-web__contact-profile--activity-type-meeting');
                    break;
                case 'other':
                    translation = this.$translate.instant('icm-web__contact-profile--activity-type-other');
                    break;
                case 'email':
                    translation = this.$translate.instant('icm-web__contact-profile--activity-type-email');
                    break;
                default:
                    translation = this.$translate.instant('icm-web__contact-profile--activity-type-note');
                    break;
            }
            return translation;
        }
    }

    angular
        .module('MW.Influencers.ActivityService', [
            'ngMaterial',
            'mwAppComponents',
            'MW.Framework.CoreUserService',
            'MW.Framework.InfluencerContactService',
            'MW.ContactManager.MwActivityModal'
        ])
        .service('ActivityService', [
            '$q',
            '$mdDialog',
            '$translate',
            'moment',
            'CoreUserService',
            'InfluencerContactService',
            ActivityService
        ]);
})();
